import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

const PublicRoute = ({ children }: any) => {
  const { isAuth } = useAuth();

  return isAuth ? <Navigate to="/dashboard" /> : children;
};

export default PublicRoute;
